{
  "actions": "Actions",
  "activateFieldAllActiveErrorMessage": "All fields are active",
  "activateFieldDescription": "The field will immediately become visible in farm maps.",
  "activateFieldLinkTo": "Activate Field",
  "activateFieldTitle": "Confirm Activate Field",
  "archiveField": "Archive Field",
  "archiveFieldAllArchivedErrorMessage": "All fields are archived",
  "archiveFieldConfirmation": "Are you sure you want to archive \"{{fieldName}}\"? The field will be hidden from farm maps but can be reactivated later.",
  "archiveFieldInstructions": "The field will be hidden from farm maps, and ignored in updates on equipment location. This will not impact data collection; if you reactivate the field any activity will be immediately available.",
  "archiveFieldLinkTo": "Archive Field",
  "archiveFieldTitle": "Archive Field",
  "area": "Area",
  "created": "Created",
  "archiveFieldsHelpDescription": "Archived fields will be hidden from the status map, but are not deleted, and can be reactivated at any time. You may want to do this for fields that are not in use during a given season.",
  "areaAcresWithVal": "{{val}} acres",
  "confirmDeleteFieldInputLabel": "Enter Field Name",
  "confirmDeleteFieldInstructions": "The field will be deleted permanently.\n\nThis action cannot be undone.",
  "confirmDeleteFieldLinkTo": "Delete Field",
  "confirmDeleteFieldTitle": "Delete Field",
  "dangerZone": "Danger Zone",
  "deleteField": "Delete Field",
  "deleteFieldConfirmation": "Are you sure you want to delete \"{{fieldName}}\"? This action cannot be undone.",
  "editFieldName": "Edit Field Name",
  "enterFieldName": "Enter Field Name",
  "fieldDetails": "Field Details",
  "fieldArchived": "This field is archived.",
  "fieldIrrigationHistoryLinkTo": "View Irrigation History",
  "viewIrrigationHistory": "View Irrigation History",
  "fieldNameInputLabel": "Field Name",
  "fieldNameInputPlaceholder": "What is the field called?",
  "fieldNamePlaceholder": "What is the field called?",
  "fieldProfileLandingLinkTo": "Field Profile",
  "fieldProfileLandingTitle": "Field Profile",
  "fieldsRosterHelpDescription": "Displays all fields that belong to this farm. You can archive and activate fields here and also navigate to the each field's profile by clicking/pressing the field card in the list.",
  "fieldsRosterLinkTo": "Manage Fields",
  "fieldsRosterListEmpty": "Your farm account has no fields",
  "fieldsRosterNewFieldButton": "New Field",
  "fieldsRosterSortKeys": {
    "alphabetical": "Field Name",
    "fieldStatus": "Field Status"
  },
  "fieldsRosterTitle": "Fields",
  "fieldsRosterTitleWithItemCount": "Fields ({{itemCount}})",
  "setFieldBoundaryInstructions": [
    "Draw your field by tapping the map. The field must have at least 3 points and be fully closed.\n\nIf you want to start over, click/press Start Over.\n\nYou will also be able to change the shape of the field later if needed."
  ],
  "setFieldBoundaryTitle": "Draw Field Boundary",
  "setFieldLabelRotationDragSliderHint": "Move slider to adjust label direction",
  "setFieldLabelRotationInstructions": "Set the field label rotation as needed",
  "setFieldLabelRotationLabel": "Rotation",
  "setFieldLabelRotationTitle": "Set Label Rotation",
  "setFieldNameInputLabel": "Field Name",
  "setFieldNameInstructions": "Enter a name for the field",
  "setFieldNameLinkTo": "Edit Label",
  "setFieldNamePlaceholderText": "What is the field called?",
  "setFieldNameTitle": "Enter Field Name",
  "setFieldRowDirectionDragSliderHint": "Move slider to adjust row direction",
  "setFieldRowDirectionFlipButton": "Flip",
  "setFieldRowDirectionInstructions": "Set the field row direction",
  "setFieldRowDirectionLinkTo": "Set Row Direction",
  "setFieldRowDirectionTitle": "Set Row Direction",
  "sortFields": "Sort Fields",
  "updateFieldBoundaryInstructions": "Update your field by dragging points on the map. The field must have at least 3 points and be fully closed.",
  "updateFieldBoundaryTitle": "Draw Field Boundary"
}
